import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageAttachments } from "../../types";
import { CarouselModal } from "../ImageViewCarousel";
import AttachmentItem from "./AttachmentItem";

interface AttachmentsProps {
  attachments: MessageAttachments[];
  color: "white" | "primary" | "negative" | "success" | "info" | undefined;
  onClickImage: (relative_path: string) => void;
}

const Attachments: React.FC<AttachmentsProps> = ({ attachments, color }) => {
  const { t } = useTranslation();
  const remainingCount = attachments.length - 4;
  const [isCarouselVisible, setCarouselVisible] = useState<[boolean, number]>([false, 0]);

  const openCarousel = (index?: number) => setCarouselVisible([true, index || 0]);
  const closeCarousel = () => setCarouselVisible([false, 0]);

  return (
    <>
      <div
        style={{
          display: attachments.length > 1 ? "grid" : "",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "10px",
          maxWidth: "400px",
          margin: "auto",
        }}
      >
        {attachments.slice(0, 4).map((item, index) => {
            if (index === 3 && remainingCount > 0) {
              return (
                <div
                  key={index}
                  className="hover:shadow-lg flex items-center justify-center border border-gray-300 rounded-lg cursor-pointer"
                  style={{
                    margin: "5px",
                    padding: "10px",
                  }}
                  onClick={() => openCarousel(3)}
                >
                  <span className="text-lg font-semibold">+{remainingCount + 1}</span>
                </div>
              );
            }
            return (
              <AttachmentItem key={item.id} item={item} index={index} openCarousel={openCarousel} color={color} />
            );
          })}

      </div>

      <CarouselModal
        visible={isCarouselVisible[0]}
        onClose={closeCarousel}
        attachments={attachments}
        index={isCarouselVisible[1]}
      />
    </>
  );
};

export default Attachments;
